module.exports = __webpack_public_path__ + "img/btn.33a74202.png";